var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5386 20H20.1924",
    stroke: "#72B567",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8655 3.50004C16.2481 3.10222 16.7669 2.87872 17.3078 2.87872C17.5757 2.87872 17.8409 2.93359 18.0884 3.0402C18.3359 3.14681 18.5607 3.30306 18.7502 3.50004C18.9396 3.69703 19.0898 3.93088 19.1923 4.18825C19.2948 4.44562 19.3476 4.72147 19.3476 5.00004C19.3476 5.27862 19.2948 5.55447 19.1923 5.81184C19.0898 6.06921 18.9396 6.30306 18.7502 6.50004L6.73092 19L2.88477 20L3.8463 16L15.8655 3.50004Z",
    stroke: "#72B567",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.ac40231b7d67e635cd660228096464b3.svg";
export { ForwardRef as ReactComponent };